export const DOC_TYPE_LABELS = {
  nda: 'NDA',
  business_reg: 'Business Registration',
  gst_cert: 'GST Certificate',
  drug_license: 'Drug License',
  pan_card: 'PAN Card',
  agreement: 'Agreement / Contract',
  others: 'Others',
};

export const docTypeLabel = t => DOC_TYPE_LABELS[t] || t.toUpperCase();
